export const FILE_SIZE_COLUMN_WIDTH = 3;
export const DELETE_COLUMN_WIDTH = 1;
export const FOR_SPOUSE_COLUMN_WIDTH = 2;
